import { useCallback, useMemo } from "react";

import { useStore } from "react-redux";

import { selectActiveLeadsType } from "app/pages/sales-intelligence/modules/leads-search";
import { useListParams } from "app/pages/sales-intelligence/modules/lists/context/ListParamsContext";
import { opportunityContactsQueryKeys } from "app/pages/sales-intelligence/pages/opportunity-list/query/queryKeyFactory";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import type {
    ContactsDataSource,
    ContactsFlowStrategy,
} from "app/pages/sales-intelligence/sub-modules/contacts-search/context/ContactsFlowContext.types";
import { selectContactSearchResultsDtoWithAggregation } from "app/pages/sales-intelligence/sub-modules/contacts-search/store/selectors";
import type { RootState } from "single-spa/store/types";

const opportunityListDataSource: ContactsDataSource = {
    revealSingle: salesApiService.contacts.revealSingleContact,
    revealMultiple: salesApiService.contacts.revealContactsById,
    exportExcel: salesApiService.contacts.exportToExcel,
};

export const useOpportunityListContactsFlowStrategy = (): ContactsFlowStrategy => {
    const store = useStore<RootState>();

    const { id: listId } = useListParams();

    const getRevealCacheKey = useCallback(() => {
        const state = store.getState();
        const leadType = selectActiveLeadsType(state);
        const dto = selectContactSearchResultsDtoWithAggregation(state);

        return opportunityContactsQueryKeys.tableData(listId, leadType, dto);
    }, [store, listId]);

    return useMemo<ContactsFlowStrategy>(
        () => ({
            dataSource: opportunityListDataSource,
            getRevealCacheKey,
        }),
        [getRevealCacheKey],
    );
};
